import { OrderBaseView } from "../../../order/base";
import { Template } from "../../../../../../core/template/index";
import { FortumApp } from "../../../../../fortumApp";
import { View } from "../../../../../../core/view/index";
import { OrderLike } from "../../../../../db/models/decontamination/order";
import { OrderItemLike } from "../../../../../db/models/decontamination/orderItem";
import { OrderItemDetailViewData } from "../../detail/index";

export default class OrderItemDetailView extends View
{
    public template = Template.lazy('/app/views/decontamination/orderItem/tab/detail/index.html');
    public app: FortumApp;
    public data: OrderItemDetailViewData;

    constructor(data?: OrderItemDetailViewData) 
    {
        super(data);
    }

    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender();
    }

    public afterRender(): PromiseLike<void>
    {        
        return super.afterRender();
    }
}
